/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { TicketGnvPagedList } from '../../models/ticket-gnv-paged-list';
import { TicketGnvSearchBody } from '../../models/ticket-gnv-search-body';
import { TicketGnvSortFieldName } from '../../models/ticket-gnv-sort-field-name';

export interface SearchTicketListCustom$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The search text to filter API
 */
  search?: string;
  sortFieldName?: TicketGnvSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * Search in historical states of ticket
 */
  historicalState?: boolean;
  
    /**
     * Body for search ticket
     */
    body?: TicketGnvSearchBody
}

export function searchTicketListCustom$Json(http: HttpClient, rootUrl: string, params?: SearchTicketListCustom$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketGnvPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchTicketListCustom$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('historicalState', params.historicalState, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketGnvPagedList>;
    })
  );
}

searchTicketListCustom$Json.PATH = '/custom/tickets/search';
